// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3acNq","name":"styles_name__17Kvw","phone":"styles_phone__EBdrq"};